// Write a 3 dot loading component for the chat application

import { css } from "../../../styled-system/css";

const Loading = () => {
  return (
    <div
      className={css({
        /**
          width: 180px;
  aspect-ratio: 8/5;
  --_g: no-repeat radial-gradient(#000 68%,#0000 71%);
  -webkit-mask: var(--_g),var(--_g),var(--_g);
  -webkit-mask-size: 25% 40%;
  background:
    conic-gradient(var(--c1) 50%,var(--c2) 0) no-repeat,
    conic-gradient(var(--c3) 50%,var(--c4) 0) no-repeat;
  background-size: 200% 50%;
  animation:
    back 3s   infinite steps(1),
    load 1.5s infinite linear;
        */
        width: "60px",
        aspectRatio: "8/5",
        background:
          "conic-gradient({colors.fuchsia} 50%, {colors.mauve} 0) no-repeat, conic-gradient({colors.purple} 50%, {colors.lightpink} 0) no-repeat",
        backgroundSize: "200% 50%",
        animation: "loadingBack 3s infinite steps(1), loadingLoad 1.5s infinite linear",
        "--_g": "no-repeat radial-gradient(#000 68%, #0000 71%)",
        mask: "var(--_g), var(--_g), var(--_g)",
        maskSize: "25% 40%",
      })}
    />
  );
};

export default Loading;
